import { WarningAmberRounded as WarningIcon } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
} from '@mui/material'

type DuplicatedFiscalNoteAlertDialogProps = DialogProps & {
  onClose: () => void
  onConfirm: () => void
}

export function DuplicatedFiscalNoteAlertDialog({
  onClose,
  onConfirm,
  ...props
}: DuplicatedFiscalNoteAlertDialogProps) {
  return (
    <Dialog maxWidth="xs" {...props}>
      <DialogContent>
        <WarningIcon
          color="warning"
          sx={{ fontSize: 80, display: 'block', mx: 'auto', my: 2 }}
        />
        Já existe uma nota fiscal emitida nos últimos 30 dias para esse tomador
        com o mesmo valor. Deseja continuar com a emissão?
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancelar
        </Button>
        <Button onClick={onConfirm}>Continuar e emitir</Button>
      </DialogActions>
    </Dialog>
  )
}
